import { useGame } from "./GameContext";
import HintList from "./HintList";
import HintDetail from "./HintDetail";
import "./hint.css";

export default function HintOverlay() {
  const { isHintOpen, hintIndex, closeHint } = useGame();
  //console.log("HintOverlay 렌더", { isHintOpen, hintIndex });
  if (!isHintOpen) return null;

  return (
    <div className="hint_overlay ">
      {hintIndex === null ? (
        <div class="box3 content_box1 ans0002 box_storage_bg">
          <div class="box_con  con_box_storage con_box_storage01">
            <div class="box_con  con_pd6 ">
              <p class="storage_tit mb8">기억 보관 상자</p>
              <p class="storage_txt mb40">기억의 조각을 모두 수집하세요.</p>
              <div class="storage_pBox">
                <HintList />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div class="box3 content_box1 ans0002 box_storage_bg">
          <div class="box_con con_box7 con_box_storage con_box_storage02">
            <div class="missionDiv">
              <div class="missionDi">
                <div class="mission_content pdTB65120">
                  <HintDetail />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <button className="hint_close" onClick={closeHint}>
        닫기
      </button>
    </div>
  );
}
